var exports = {
  "kL": "xf0b3b88a--1356ec--container",
  "om": "xf0b3b88a--1356ec--block",
  "o1": "xf0b3b88a--1356ec--actions",
};

module.exports = exports;
